import React, { useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const GetDiscountTemplateWidget = ({ qrCodeTabData,widgetId }) => {
    const {
        is_website_frontend,
        qr_code_size,
        title,
        call_to_action_text,
        caption,
        frame_type,
        generate_type,
        generate_url,
        generate_location,
        title_color,
        foreground_color,
        background_color,
        frame_color,
        caption_color,
        title_font_size,
        call_to_action_font_size,
        caption_font_size,
    } = qrCodeTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/qr-code/temp-css/QRCode.css`;
        if (widgetId) {
            link.setAttribute("qr-code-data-dynamic-css", "qr-code");
        } else {
            link.setAttribute("data-dynamic-css", "qr-code");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="qr-code"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    //Color Contrast Combination
    const getContrastColor = (hexColor = '#ffffff') => {
        let hex = hexColor.replace('#', '');

        // Expand shorthand hex (e.g. "fff") to full form (e.g. "ffffff")
        if (hex.length === 3) {
            hex = hex.split('').map(c => c + c).join('');
        }

        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        // Calculate brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        return brightness > 128 ? '#000000' : '#ffffff'; 
    };

    //Generate QR code Value
    const generateQRCodeValue = (generate_type) => {
        switch (generate_type) {
            case 'URL':
                return generate_url || '';
            case 'email':
                return `mailto:testing@gmail.com`;
            case 'phone':
                return `tel:9816354872`;
            case 'sms':
                return `sms:hello`;
            case 'Location':
                return generate_location;
            default:
                return '';
        }
    };
    const qr_code_value = generateQRCodeValue(generate_type);

    let custom_class_name = '';
    let temp_name = 'Get_Discount_Temp';
    if (frame_type === "frame_1" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'frame_1';
    } else if (frame_type === "frame_2" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'frame_2';
    } else if (frame_type === "frame_3" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'get-discount-temp';
    } else if (frame_type === "frame_4" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'event-save-temp';
    } else if (frame_type === "frame_5" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'frame_5 view-pdf-temp';
    } else if (frame_type === "frame_6" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'view-pdf-temp';
    } else if (frame_type === "frame_7" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'save-my-contact-temp frame_7';
    } else if (frame_type === "frame_8" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'frame_8';
    } else if (frame_type === "frame_9" && temp_name === 'Get_Discount_Temp') {
        custom_class_name = 'rate-on-facebook-temp'; 
    } else if (frame_type === "frame_9" && temp_name === 'Rate_On_Tripadvisor_Temp') {
        custom_class_name = 'rate-on-tripadvisor-temp'; 
    }

    return (
        <>
            <div className={`upgadeify qr_code_inner qr_code ${custom_class_name} ${is_website_frontend}`}>
  {frame_type === "frame_1" && (
                <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{width: qr_code_size,height: qr_code_size,display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 1} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />
                    </div>

                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}
            
            {frame_type === "frame_2" && (
                <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{width: qr_code_size,height: qr_code_size,display: 'flex',alignItems: 'center',justifyContent: 'center', border: `8px solid ${frame_color || '#000'}`, borderRadius:"8px"}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />
                    </div>

                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}

            {frame_type === "frame_3" && (
                <div className='qr_code_template' style={{background: 'transparent'}}>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{backgroundColor: frame_color, textAlign:'center', border: `5px solid ${frame_color || '#000'}`}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />

                         {call_to_action_text && (
                        <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center', paddingBottom: '0', width: `${parseInt(qr_code_size) * 0.9}px`}}>
                            <span className='qr_code_template_title' style={{
                                color: getContrastColor(frame_color),
                                fontSize: call_to_action_font_size,
                            }}>{call_to_action_text}</span>
                        </div>
                    )}

                    </div>

                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}


            {frame_type === "frame_4" && (
                <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{textAlign:'center', padding:'0'}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.6} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />

                        {call_to_action_text && (
                            <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center', marginTop:'10px', width: `${parseInt(qr_code_size) * 0.9}px`}}>
                                <div className='qr_code_template_body_before' style={{backgroundColor: frame_color}}></div>
                                <span className='qr_code_template_title' style={{
                                    color: getContrastColor(frame_color),
                                    fontSize: call_to_action_font_size,
                                }}>{call_to_action_text}</span>
                            </div>
                        )}
                    </div>

                    

                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}


            {frame_type === "frame_5" && (
                 <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{textAlign:'center', padding:'0'}}>
                        <QRCodeCanvas style={{border: `12px solid ${frame_color || '#000'}`, borderRadius: '8px'}} value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />

                        {call_to_action_text && (
                            <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center', marginTop:'10px', width: `${parseInt(qr_code_size) * 0.9}px`}}>
                                <div className='qr_code_template_body_before' style={{backgroundColor: frame_color}}></div>
                                <span className='qr_code_template_title' style={{
                                    color: getContrastColor(frame_color),
                                    fontSize: call_to_action_font_size,
                                }}>{call_to_action_text}</span>
                            </div>
                        )}
                    </div>

                    

                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}


            {frame_type === "frame_6" && (
                 <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_header' style={{textAlign:'center', padding:'0'}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.6} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />

                        {call_to_action_text && (
                            <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center', marginTop:'10px', width: `${parseInt(qr_code_size) * 0.9}px`}}>
                                <span className='qr_code_template_title' style={{
                                    color: getContrastColor(frame_color),
                                    fontSize: call_to_action_font_size,
                                }}>{call_to_action_text}</span>
                            </div>
                        )}
                    </div>
      
                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}


            {frame_type === "frame_7" && (
                <div className='qr_code_template_frame_7'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}
                <div className='qr_code_template'>
                    <div className='qr_code_template_header' style={{width: qr_code_size,height: qr_code_size,display: 'flex',alignItems: 'center',justifyContent: 'center', backgroundColor: frame_color}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />
                    </div>

                    {call_to_action_text && (
                        <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                           <div className='qr_code_template_header_caption' style={{marginBlock: '0'}}>  <span className='qr_code_template_title' style={{
                                color: getContrastColor(frame_color),
                                fontSize: call_to_action_font_size, width: qr_code_size,
                            }}>{call_to_action_text}</span>
                             {caption && (
                       
                            <p style={{ color: caption_color,fontSize: caption_font_size, marginTop: '8px', width: qr_code_size, }}>{caption}</p>
                     
                    )}
                       </div>   
                        </div>
                    )}

                   
                </div>
                </div>
            )}


            {frame_type === "frame_8" && (
                <div className='qr_code_template'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                    <div className='qr_code_template_top'>
                         <div className='qr_code_template_top_header' style={{backgroundColor: frame_color, width: qr_code_size}}>
                        <h2 style={{color: getContrastColor(frame_color)}}>-</h2>
                    </div>
                    <div className='qr_code_template_header' style={{width: qr_code_size,height: qr_code_size,display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />
                    </div>

                    {call_to_action_text && (
                        <div className='qr_code_template_body' style={{backgroundColor: frame_color,display: 'flex',alignItems: 'center',justifyContent: 'center', width: qr_code_size}}>
                            <div className='qr_code_template_body_before' style={{backgroundColor: frame_color}}></div>
                            <span className='qr_code_template_title' style={{
                                color: getContrastColor(frame_color),
                                fontSize: call_to_action_font_size,
                            }}>{call_to_action_text}</span>
                        </div>
                    )}

                    </div>    
                   
                    {caption && (
                        <div className='qr_code_template_header_caption'>
                            <p style={{ color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                </div>
            )}


            {frame_type === "frame_9" && (
                <div className='qr_code_template_frame_9'>
                    {title && (
                        <div className='qr_code_template_header_title'>
                            <h2 style={{ color: title_color, fontSize: title_font_size }}>{title}</h2>
                        </div>
                    )}

                   <div className='qr_code_template' style={{backgroundColor: frame_color}}>
                         <div className='qr_code_template_header' style={{width: qr_code_size,height: qr_code_size,display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                        <QRCodeCanvas value={qr_code_value || 'https://dashboard.upgadeify.com'} size={parseInt(qr_code_size) * 0.9} bgColor={background_color || '#ffffff'} fgColor={foreground_color || '#000000'} />
                    </div>
                    <div className='qr_code_template_body' style={{ width: `${parseInt(qr_code_size) * 1.4}px`}}>
                        {call_to_action_text && (
                        <div className='' style={{display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                            <span className='qr_code_template_title' style={{
                                color: getContrastColor(frame_color),
                                fontSize: call_to_action_font_size,
                            }}>{call_to_action_text}</span>
                        </div>
                    )}

                    {caption && (
                        <div className='qr_code_template_header_caption' style={{marginTop: '5px'}}>
                            <p style={{ textAlign:'left', color: caption_color,fontSize: caption_font_size }}>{caption}</p>
                        </div>
                    )}
                     </div>   
                    </div>
                    
                </div>
            )}
            </div>
        </>
    );
};

export default GetDiscountTemplateWidget;
